import FileSaver from "file-saver";
import {BudgetingType} from "../../../BudgetingType";
import {AppConfig} from "../../../hooks/useConfig";
import {ExportPropertyBudgetQuery, GetBudgetSeasonExportDataQuery} from "../../../__generated__/generated_types";
import {YearDefinition} from "../../annualsummary/YearDefinitions";
import {BudgetExportFormat} from "../BudgetExportData";
import {formatForAppfolio, formatAsReport, formatForYardi, formatForArbitraryMonthRange} from "./formatters";
import {Property} from "../../../contexts/properties/logic";
import {formatExportTimestampSlug} from "../../../utils/formatters";

export function exportCsv(
        exportFormat: BudgetExportFormat.CSV_REPORT | BudgetExportFormat.CSV_APPFOLIO | BudgetExportFormat.CSV_YARDI | BudgetExportFormat.CSV_YARDI_1_cent,
        tab: BudgetingType,
        referenceYear: YearDefinition,
        data: ExportPropertyBudgetQuery,
        config: AppConfig
): void {
        let formattedData = "";

        if (exportFormat == BudgetExportFormat.CSV_REPORT) {
            formattedData = formatAsReport({
                tab: tab,
                referenceYear: referenceYear,
                data: data,
                config: config
            });
        }
        else if (exportFormat == BudgetExportFormat.CSV_APPFOLIO) {
            formattedData = formatForAppfolio({
                tab: tab,
                data: data,
                config: config
            });
        }
        else if (exportFormat == BudgetExportFormat.CSV_YARDI || exportFormat == BudgetExportFormat.CSV_YARDI_1_cent) {
            formattedData = formatForYardi({
                tab: tab,
                data: data,
                config: config,
                oneCentInsteadZero: exportFormat == BudgetExportFormat.CSV_YARDI_1_cent
            });
        }
        const saveData = new Blob([formattedData], {type: "text/csv;charset=utf-8"});
        let year = config.year;
        let periodName = "Reforecast";
        if (tab == BudgetingType.BUDGET) {
            year = config.year + 1;
            periodName = "Budget";
        }
        const property = config.properties.currentProperty;
        if(property && property.isAcquisitionProperty) {
            year = property.acquisitionBudgetYear ?? property.reforecastYear;
            periodName = "Acquisition Budget";
        }

        const fileName = `${year} ${periodName} - ${config.properties.currentProperty?.name ?? ""}`;
        FileSaver.saveAs(saveData, `${fileName}_${formatExportTimestampSlug(new Date())}.csv`);
}

export function exportArbitraryMonthRangeCsv(params:{
    data: GetBudgetSeasonExportDataQuery,
    startMonth: number, // from 0 to 23
    months: number, // from 1 to 24 minus start month is inclusive
    budgetYear: number,
    property: Property,
}): void {
    const {data, startMonth, months, budgetYear, property} = params;
    const formattedData = formatForArbitraryMonthRange(data, startMonth, months, property, budgetYear);
    const saveData = new Blob([formattedData], {type: "text/csv;charset=utf-8"});
    FileSaver.saveAs(saveData, `${property.name}_${formatExportTimestampSlug(new Date())}.csv`);
}